// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8ff2ba6","453":"1b2803a3","455":"d6e46bd3"}[chunkId] + ".chunk.js";
};